import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TATReportApi } from '../api/tatreport.api';
import { switchMap, map } from 'rxjs/operators';
import { TATReportData, TATReport } from '../../../interfaces/lab/tatreport';


@Injectable()

export class TATReportService extends TATReportData{

  constructor(private api: TATReportApi) {
    super();
  } 
  list(url: string): Observable<TATReport[]> { 
    return this.api.list(url);
  } 

  getById(url:string): Observable<TATReport>{
      return this.api.getById(url);
  }

  create(url: string, data:TATReport): Observable<TATReport[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:TATReport): Observable<TATReport> { 
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
